import type { IAnchor } from './types';
import { useTranslation } from '@klv/hooks/useTranslation';

export const Anchor = ({
  className = '',
  href,
  to, // for backward compatibility
  children,
  text = '',
  ...props
}: IAnchor & React.HTMLProps<HTMLAnchorElement>) => {
  const { t } = useTranslation();
  
  // Get the path prefix from the translation
  let prefix = t('langCodes_pathPrefix');
  if (prefix !== '') {
    prefix = '/' + prefix;
  }
  
  // Create a variable to store the url that we can adjust as needed.
  let url = href ? href : to;

  // do not allow the prefix to be prepended if it already starts with the prefix.
  if (href && href.startsWith(prefix)) {
    prefix = '';
  }
  
  // If the url is not null and does not start with http or #, let's add our site prefix
  if (url && !url.startsWith('http') && !url.startsWith('#') && !url.startsWith('/hc')) {
    // if the link is not an external link, let's add our site prefix
    url = prefix + url;

    // if the link ends with a dash, let's remove it
    url = url.endsWith('-') ? url.slice(0, -1) : url;
  }
  return (
    <a {...{ ...props, href: url, className } }>
      {children ? children : text}
    </a>
  );
};
